import { createApi } from "@reduxjs/toolkit/query/react";
import {
  SalesReturnSearchResult,
  SalesReturnSearch,
  SalesReturnSummaryResult,
} from "@/types/amazon/amazonSalesReturn";
import { marketPlaceBaseQueryWrapper } from "@/utils/rtkHelper";

export const AmazonSalesReturnApi = createApi({
  reducerPath: "AmazonSalesReturnApi",
  baseQuery: marketPlaceBaseQueryWrapper,
  tagTypes: ["amazonsalesReturn"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    uploadSalesReturn: builder.mutation({
      query: ({ formData }) => ({
        url: `/amazonsalesreturn/salesreturn/xlsx`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["amazonsalesReturn"],
    }),
    searchReturn: builder.query<SalesReturnSearchResult, SalesReturnSearch>({
      query: (input) => {
        return {
          url: `/amazonsalesreturn/salesreturn`,
          method: "POST",
          body: { ...input, export: false },
        };
      },
      providesTags: ["amazonsalesReturn"],
    }),
    exportSalesReturn: builder.mutation<Blob, SalesReturnSearch>({
      query: (input) => ({
        url: `/amazonsalesreturn/salesreturn`,
        method: "POST",
        body: { ...input, export: true },
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    summaryOrdesSalesReturn: builder.query<
      SalesReturnSummaryResult,
      SalesReturnSearch
    >({
      query: (input) => ({
        url: `/amazonsalesreturn/sales_return_summary`,
        method: "POST",
        body: input,
      }),
      providesTags: ["amazonsalesReturn"],
    }),
    deleteSalesReturns: builder.mutation<void, string[]>({
      query: (ids) => ({
        url: "/amazonsalesreturn/delete",
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["amazonsalesReturn"],
    }),
  }),
});

export const {
  useUploadSalesReturnMutation,
  useSearchReturnQuery,
  useExportSalesReturnMutation,
  useLazySearchReturnQuery,
  useSummaryOrdesSalesReturnQuery,
  useDeleteSalesReturnsMutation,
} = AmazonSalesReturnApi;
